import PopularGames from "./PopularGames";

export default PopularGames;